import { render, staticRenderFns } from "./PlayCode.vue?vue&type=template&id=db5222b4"
import script from "./PlayCode.vue?vue&type=script&lang=js"
export * from "./PlayCode.vue?vue&type=script&lang=js"
import style0 from "./PlayCode.vue?vue&type=style&index=0&id=db5222b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports